import React from 'react'
import { connect } from 'react-redux'
import { ContentHeader, Modal, NoContentBox } from 'components/basic'
import { DashboardBox } from 'components/core'
import FlowView from 'components/core/FlowView'
import http from 'API/http'
import { Installation } from 'config'
const dashboardItems = [
  {
    title: 'Available Accesses',
    icon: 'fa-home',
    buttons: [
      {link: '/#/export/access', content: <span> <i className='fa fa-cloud-download' /> EXPORT.CSV</span>}
    ]
  }, {
    title: 'Active Services',
    icon: 'fa-cog',
    buttons: [
      {link: '/#/export/services', content: <span> <i className='fa fa-cloud-download' /> EXPORT.CSV</span>}
    ]
  }
]
class AccessOverview extends FlowView {
  constructor (props) {
    super(props, 'Overview')
    this.state = {
      accesses: [],
      periods: [],
      search: null,
      searchQuery: '',
      searching: false,
      modalState: false,
      billingModal: false
    }
  }
  async componentDidMount () {
    var err, res
    [err, res] = await http.get('2.3/billing/periods')
    if (err) return
    this.setState({periods: res.data})
  }
  async searchAccess () {
    this.setState({searching: true})
    clearTimeout(this.state.search)
    this.state.search = setTimeout(async () => {
      var err, res
      [err, res] = await http.get('2.3/accesses/search/' + this.state.searchQuery)
      if (err) return this.setState({accesses: [], searching: false})
      this.setState({accesses: res.data, searching: false})
    }, 150)
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Dashboard' />
        <hr />
        <div className='event-configration'>
          {dashboardItems.map(item => <DashboardBox key={item.icon} {...item} />)}
          {Installation.enable.billingExport &&
          <div className='namespace col-lg-2 col-md-3 col-sm-6 col-xs-12'>
            <div className='namespace-inner'>
              <div className='namespace-text'>
                <h3>Billing</h3>
                <i className='fa fa-fw fa-balance-scale' />
              </div>
              <a onClick={e => this.setState({billingModal: true})} className='btn full-width btn-primary'><span> <i className='fa fa-cloud-download' /> EXPORT.CSV</span></a>
            </div>
          </div>}
          <div className='namespace col-lg-2 col-md-3 col-sm-6 col-xs-12'>
            <div className='namespace-inner'>
              <div className='namespace-text'>
                <h3>Help</h3>
                <i className='fa fa-fw fa-question-circle' />
              </div>
              <a onClick={e => this.setState({modalState: true})} className='btn full-width btn-primary'>Open Help</a>
            </div>
          </div>
          <div className='namespace col-lg-2 col-md-3 col-sm-6 col-xs-12'>
            <div className='namespace-inner'>
              <div className='namespace-text'>
                <h3>About Flow</h3>
                <i className='fa fa-fw fa-globe' />
              </div>
              <a onClick={e => (window.location.hash = '/about')} className='btn full-width btn-primary'>View</a>
            </div>
          </div>
        </div>
        <Modal title='Help' isOpen={this.state.modalState} close={e => this.setState({modalState: false})}>
          <ul>
            <li>To Connect, Disconnect or Troubleshoot services search for an access in the top right.</li>
            <li>To create new Trouble Ticket search for an access in the top right.</li>
            <li>To list and search for open tickets click on Trouble Tickets in the left menu.</li>
            <li>To list order history click on Order Events in the left menu</li>
          </ul>
          <h4>Support</h4>
          <p>If an error occurs in Flow Access please contact the ISP, if you require user support please contact <b>flow-support@maintrac.se</b></p>
        </Modal>
        <Modal title='Billing Export' isOpen={this.state.billingModal} close={e => this.setState({billingModal: false})}>
          {!this.state.periods.length && <NoContentBox icon='folder-o' text='No periods available for exporting.' />}
          <ul className='list-group'>
            {this.state.periods.map(period => {
              return <li key={period.period} className='list-group-item'>
                <a className='badge badge-primary' href={'/#/export/billing/' + period.period}>Download</a>
                {period.period}
              </li>
            })}
          </ul>
        </Modal>
      </div>
    )
  }
}
//eslint-disable-next-line
AccessOverview = connect(state => state.siteReducer)(AccessOverview)
export default AccessOverview



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/access/overview.js